<script>
import Home from './Home.vue'

export default {
    name: 'HomeClone',
    extends: Home
}
</script>
